import {TranslateService} from '@ngx-translate/core';

import {ChartUtils} from '../../+postpayroll/check/key-metrics/charts/chart.utils';
import {BasicLine} from '../../+postpayroll/check/key-metrics/charts/line/basic-line';
import {Chart} from '../../+postpayroll/check/key-metrics/key-metrics.interfaces';
import {LocalizationService} from '../../shared/localization/localization.service';
import {ChartBoxElement, DashboardBox, ResponseChartBox} from '../dashboard.interfaces';

import {DashboardChartUtils} from './dashboard-chart.utils';
import {Scss} from '../../shared/utils/scss';

export class FTEandHeadcountChart extends BasicLine {
  constructor(chartBox: ResponseChartBox,
              translate: TranslateService,
              localization: LocalizationService,
              isAvg: boolean) {
    const params = chartBox.params;
    const chart: Chart = ChartUtils.getEmptyChart();

    Object.keys(params).forEach((key: string) => {
      params[key].forEach((element: ChartBoxElement) => {
        chart.data.push({
          category: element.name,
          name: key,
          value: element.value,
          metadata: element.link
        });
      });
    });

    chart.type = chartBox.cardType;

    super(chart, translate, localization, isAvg);

    this.legend = {
      orient: 'horizontal',
      top: 0
    };

    this.xAxis = [{
      data: DashboardChartUtils.formatCategories(this.xAxis[0].data, translate),
      axisLabel: DashboardChartUtils.getAxisOptions(),
      axisLine: {
        show: true
      },
      axisTick: {
        show: true,
        alignWithLabel: true,
      }
    }];

    this.yAxis = [{
      axisLine: {
        show: true
      },
      axisTick: {
        show: true,
        alignWithLabel: true,
      }
    }];

    this.grid = DashboardChartUtils.getGridOptions();
    this.animation = true;

    DashboardChartUtils.setLinks(this.series, this.chart, this.categories);
    this.tooltip.position = DashboardChartUtils.getTooltipPositionFunc(<DashboardBox>chartBox);

    const headcount = Scss.variable('chart-headcount');
    const fte = Scss.variable('chart-fte');
    if (headcount && fte) {
      this.color = [headcount, fte];
    }
  }

  public sortCategories(array: string[]): string[] {
    return DashboardChartUtils.monthSort(array);
  }
}
